export default {
  title: 'O seu website está pronto',
  body_one: 'As reservas continuam desativadas para {{count}} restaurante:',
  body_other: 'As reservas continuam desativadas para {{count}} restaurantes:',
  reasons: {
    license_required: 'Requer um Plano Parceiro',
    notification_email_required:
      'É necessário um email para as notificações de reservas. Adicione-o ao ativar as reservas.',
    switched_off: 'Desativado nas definições de reservas',
    activation_failed: 'Não foi possível ativar. Tente novamente nas definições de reservas.',
  },
  buttons: {
    open_settings: 'Abrir definições de reservas',
    continue: 'Continuar para o criador de websites',
  },
};
